<template>
  <div
    class="flex overflow-x-auto scrollbar-none gap-8 mt-4 md:mt-12 mb-16 -mx-24 px-24 py-4 md:px-40 md:mx-0"
  >
    <RevSkeleton
      v-for="num in 4"
      :key="num"
      width="136px"
      height="40px"
      shape="circle"
    />
  </div>
</template>

<script setup lang="ts">
import { RevSkeleton } from '@ds/components/Skeleton'
</script>
